import { render } from "./SignContractTemplate.vue?vue&type=template&id=38fff4b5&scoped=true"
import script from "./SignContractTemplate.vue?vue&type=script&lang=js"
export * from "./SignContractTemplate.vue?vue&type=script&lang=js"

import "./SignContractTemplate.vue?vue&type=style&index=0&id=38fff4b5&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fff4b5"]])

export default __exports__